import { render, staticRenderFns } from "./SummaryScreen.vue?vue&type=template&id=34d51171&scoped=true&"
import script from "./SummaryScreen.vue?vue&type=script&lang=js&"
export * from "./SummaryScreen.vue?vue&type=script&lang=js&"
import style0 from "./SummaryScreen.vue?vue&type=style&index=0&id=34d51171&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d51171",
  null
  
)

export default component.exports